var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-z-[-10]"},[_vm._v(" "+_vm._s(_vm.item.client_name)+" "),(_vm.item.properties_count && _vm.item.properties_count > 0)?_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-notebook-check ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }